var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","pa-8":"","pa-md-16":""}},[(_vm.locale == 'de')?_c('ImpressumDE'):_vm._e(),(_vm.locale == 'en')?_c('ImpressumEN'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }